import { api } from '@/fsd/shared/api';
import { IOrganization } from '../model/types/types';

export const getOrganisations = async (): Promise<IOrganization[]> => {
  const organizations = await api.get<{ data: IOrganization[] }>(
    '/api/v1/organisation/'
  );

  return organizations.data;
};
